export default "__VITE_ASSET__FO$CGe6h__"